import React from "react";

const Header = () => {
  return <div className="header">EXPENSE TRACKER</div>;
};

export default Header;
